export default "__VITE_ASSET__CArMJjyA__"